var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-600 -100 5000 5000",
    style: {
      transform: "rotate(180deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1903 4450 c-528 -74 -899 -543 -844 -1064 45 -436 364 -780 798                      -862 116 -22 294 -15 413 15 248 64 480 242 605 465 174 311 165 694 -23 996                      -56 90 -174 216 -258 276 -86 62 -234 130 -334 154 -98 23 -267 33 -357 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165 3483 c2 -16 9 -73 15 -128 45 -403 174 -769 359 -1015 139 -185                      419 -426 656 -565 15 -9 6 -15 -56 -39 -334 -130 -590 -357 -746 -662 -102                      -198 -176 -497 -199 -807 l-7 -87 542 0 541 0 0 88 c0 201 60 522 126 671 84                      190 275 349 510 426 93 30 132 31 220 4 243 -74 448 -248 530 -449 56 -140                      107 -404 120 -633 l6 -107 539 0 540 0 -6 63 c-58 581 -181 901 -455 1176                      -135 135 -285 233 -476 308 l-93 37 72 44 c223 138 510 398 634 575 173 246                      295 629 338 1060 l7 67 -341 0 -340 0 -6 -47 c-56 -452 -160 -703 -363 -878                      -118 -102 -226 -174 -363 -240 -121 -58 -400 -155 -446 -155 -35 0 -224 59                      -346 109 -200 81 -391 207 -524 343 -148 151 -245 394 -289 716 -9 70 -18 133                      -20 140 -3 9 -80 12 -343 12 l-340 0 4 -27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpfx);
export default __webpack_public_path__ + "static/media/ipfx.6646d4c6b15495d950e7719011c72b81.svg";
export { ForwardRef as ReactComponent };